import { render, staticRenderFns } from "./UpdateInvoiceDialog.vue?vue&type=template&id=ece10e46"
import script from "./UpdateInvoiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateInvoiceDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports